/**
 * Simultaneously update l/s and m3/h airflow inputs on Products filter
 */
jQuery(document).ready(function($) {
function checkNumbersMinMax() {
    var lsInput = $('input[name="_sfm_airflow_ls_min[]"].sf-range-min');
    var newVal = parseInt( lsInput.val() );
	var max = parseInt( lsInput.attr('max') );
	var min = parseInt( lsInput.attr('min') );

	if ( newVal > max ) {
		lsInput.val( lsInput.attr('max') );
	}
	if ( newVal < min ) {
		lsInput.val( lsInput.attr('min') );
    }
    
    var mhInput = $('input[name="_sfm_airflow_mh_min[]"].sf-range-min');
    var newVal = parseInt( mhInput.val() );
	var max = parseInt( mhInput.attr('max') );
	var min = parseInt( mhInput.attr('min') );

	if ( newVal > max ) {
		mhInput.val( mhInput.attr('max') );
	}

	if ( newVal < min ) {
		mhInput.val( mhInput.attr('min') );
	}
}

$('input[name="_sfm_airflow_ls_min[]"].sf-range-min').on('change blur', function() {
    $('input[name="_sfm_airflow_mh_min[]"].sf-range-min').val( Math.floor( 3.6 * $(this).val() ) );
	checkNumbersMinMax();
});

$('input[name="_sfm_airflow_ls_min[]"].sf-range-min').on('input', function() {
	$('input[name="_sfm_airflow_mh_min[]"].sf-range-min').val( Math.floor( 3.6 * $(this).val() ) );
});

$('input[name="_sfm_airflow_mh_min[]"].sf-range-min').on('change blur', function() {
    $('input[name="_sfm_airflow_ls_min[]"].sf-range-min').val( Math.floor( $(this).val() / 3.6 ) );
    checkNumbersMinMax();
});

$('input[name="_sfm_airflow_mh_min[]"].sf-range-min').on('input', function() {
	$('input[name="_sfm_airflow_ls_min[]"].sf-range-min').val( Math.floor( $(this).val() / 3.6 ) );
});
});